import React from 'react'
import withStyles from 'react-jss'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import previewBaneerStyles from './preview-baneer-style'

const PreviewBaneer = props =>
  <p className={props.classes.baneer}>
    {props.message}
    <span className={classNames('fal', 'fa-times-circle', props.classes.close)} onClick={props.close} />
  </p>

PreviewBaneer.propTypes = {
  classes: PropTypes.object.isRequired,
  close: PropTypes.func.isRequired,
  message: PropTypes.string.isRequired
}

export default withStyles(previewBaneerStyles)(PreviewBaneer)
